import classNames from 'clsx';
import React, { useContext } from 'react';

import { pageCount } from './Buttons';
import styles from './NewUser.scss';
import NewUserContext from './NewUserContext';

function DotProgressIndicator() {
  const {
    state: { activePage }
  } = useContext(NewUserContext);

  return (
    <div className={styles.dots}>
      {Array.from({ length: pageCount }).map((_, index) => (
        <div
          className={classNames(styles.dot, { [styles.active]: activePage === index })}
          key={index}
        />
      ))}
    </div>
  );
}

export default DotProgressIndicator;
